import React, { useState } from 'react';

import ActionButton from '../../elements/ActionButton';
import DeleteButton from '../../elements/DeleteButton';
import EditButton from '../../elements/EditButton';
import Card from '../../elements/common/Card';

import SlidersApi from 'Api/CRM/Modules/SlidersApi';
import SliderItem from 'Api/Models/SliderItem';
import useGlobalState from 'crm/GlobalStateContext';
import TableHead from 'crm/elements/common/TableHead';
import TableLoader from 'crm/elements/common/TableLoader';
import { PERMISSION } from 'crm/helpers/Permissions';
import useNumberParams from 'crm/hooks/useNumberParams';
import useOnce from 'crm/hooks/useOnce';

function SliderShow() {
    const { languages } = useGlobalState();
    const { id } = useNumberParams();
    const [sliderItems, setSliderItems] = useState<SliderItem[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const updateSliderItems = () => {
        setIsLoading(true);
        SlidersApi.getItemsBySliderId(id)
            .then(setSliderItems)
            .finally(() => setIsLoading(false));
    };

    const getLanguageCode = (languageId: number): string =>
        languages.find((lang) => lang.id === languageId)?.code.toUpperCase() ?? '';

    useOnce(updateSliderItems);

    const getTableBody = () =>
        sliderItems.length ? (
            sliderItems.map((sliderItem) => (
                <tr key={sliderItem.id}>
                    <td>{sliderItem.id}</td>
                    <td>{getLanguageCode(sliderItem.language_id)}</td>
                    <td>
                        <img alt="" src={sliderItem.image_url} className="img thumbnail" />
                    </td>
                    <td>
                        <img alt="" src={sliderItem.mobile_image_url} className="img thumbnail" />
                    </td>
                    <td>
                        <a href={sliderItem.redirection_url}>{sliderItem.redirection_url}</a>
                    </td>
                    <td>{sliderItem.alt_value}</td>
                    <td>{sliderItem.lottery_id}</td>
                    <td>
                        <EditButton
                            url={`/slider_item/${sliderItem.id}/`}
                            permissions={[PERMISSION.UPDATE_SLIDER_ITEM]}
                        />
                        <DeleteButton
                            url={`/crea/api/slider_items/${sliderItem.id}`}
                            permissions={[PERMISSION.DELETE_SLIDER_ITEM]}
                            action={updateSliderItems}
                        />
                    </td>
                </tr>
            ))
        ) : (
            <tr>
                <td colSpan={7}>Slider doesnt have slides yet...</td>
            </tr>
        );

    return (
        <Card>
            <ActionButton
                url={`/slider/${id}/create`}
                title="Add new slider item"
                permissions={[PERMISSION.CREATE_SLIDER_ITEM]}
            />
            <TableLoader isLoading={isLoading}>
                <table className="table">
                    <TableHead>
                        <th>ID</th>
                        <th>Language</th>
                        <th>Image</th>
                        <th>Mobile Image</th>
                        <th>Link to</th>
                        <th>Alt value</th>
                        <th>Choose Lottery</th>
                        <div />
                    </TableHead>
                    <tbody>{getTableBody()}</tbody>
                </table>
            </TableLoader>
        </Card>
    );
}

export default SliderShow;
